import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { View, ScrollView, KeyboardAvoidingView } from 'react-native'

import {
  QuickActionMenu,
  VFDropdown,
  VFInput,
  VFText,
  VFButton
} from '@vfgroup-oneplatform/foundation/Components'
import { useTheme, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import styles from './AddLocation.Styles'

const AddLocation = ({
  isVisible,
  toggleModal,
  citiesOptions,
  addressInfo,
  setAddressInfo,
  setSaveInfo,
  continueToNextStep
}) => {

  const theme = useTheme()

  const extraDataRef = useRef()
  const streetRef = useRef()

  const [notValidExtraData, setNotValidExtraData] = useState(false)
  const [notValidStreet, setNotValidStreet] = useState(false)

  const checkExtraData = () => {
    if (addressInfo.buildingNo?.length === 0) {
      setNotValidExtraData(true)
    } else {
      setNotValidExtraData(false)
    }
  }

  const checkStreet = () => {
    const streetRegex = /[A-Za-z]{1}/

    const isValid = streetRegex.test(addressInfo.street)

    if (addressInfo.street?.length < 4 || !isValid) {
      setNotValidStreet(true)
    } else {
      setNotValidStreet(false)
    }
  }

  const isButtonDisabled = () => {
    const isDisabled = !addressInfo.city || !addressInfo.street || !addressInfo.extraData
      || notValidExtraData || notValidStreet


    return isDisabled
  }

  const onButtonPress = () => {
    setSaveInfo(true)
    toggleModal()
    setTimeout(() => {
      continueToNextStep()
    }, 100)
  }


  return (
    <QuickActionMenu
      isVisible={isVisible}
      toggleModal={toggleModal}
      type='secondary'
      headerStyle={styles.headerStyle}
      title='book_appointment_add_location'
      withKeyboardAvoid={true}
      scrollViewProps={{
        keyboardShouldPersistTaps: "always"
      }}
    >
      <VFText
        i18nKey='book_appointment_add_location_modal_title'
        style={styles.titleStyle(theme)}
      />
      <VFDropdown
        style={styles.inputContainer}
        items={citiesOptions}
        placeholder={{ label: 'book_appointment_city_placeholder' }}
        value={citiesOptions.find(el => el.value === addressInfo.city)?.label}
        itemTextStyle={[styles.inputText(theme), { opacity: 0.6 }]}
        onValueChange={(value) => setAddressInfo(prev => { return { ...prev, city: value } })}
        titleStyle={{ color: theme.colors.textInput.default.baseColor }}
        selectedItem={citiesOptions.find(el => el.value === addressInfo.city) || {}}
        isSearchable={true}
        activeBorderColor={theme.colors.textInput.default.baseColor}
        textColor={theme.colors.textColor}
        borderColor={theme.colors.textInput.default.baseColor}
        containerStyle={styles.inputContainer}
        labelStyle={styles.inputText(theme)}
        flatListProps={{
          keyboardShouldPersistTaps: "always"
        }}
      />
      <View style={{ marginTop: -49 }}>

        <VFInput
          fieldRef={ref => {
            streetRef.current = ref
          }}
          label="book_appointment_street_placeholder"
          value={addressInfo.street}
          onChangeText={(text) => setAddressInfo(prev => { return { ...prev, street: text } })}
          containerStyle={styles.inputContainer}
          labelTextStyle={styles.inputText(theme)}
          style={styles.inputText(theme)}
          tintColor={notValidStreet ? Colors.vfRed : theme.colors.textInput.default.tintColor}
          baseColor={notValidStreet ? Colors.vfRed : theme.colors.textInput.default.baseColor}
          onBlur={checkStreet}
          helperTextColor={Colors.vfRed}
          helperText="book_appointment_street_input_not_valid"
          showHelperText={notValidStreet}
        />

        <VFInput
          fieldRef={ref => {
            extraDataRef.current = ref
          }}
          label="book_appointment_extra_data_placeholder"
          value={addressInfo?.extraData}
          onChangeText={(text) => setAddressInfo(prev => { return { ...prev, extraData: text } })}
          containerStyle={styles.inputContainer}
          labelTextStyle={styles.inputText(theme)}
          style={styles.inputText(theme)}
          tintColor={notValidExtraData ? Colors.vfRed : theme.colors.textInput.default.tintColor}
          baseColor={notValidExtraData ? Colors.vfRed : theme.colors.textInput.default.baseColor}
          onBlur={checkExtraData}
          helperTextColor={Colors.vfRed}
          helperText="book_appointment_extraData_input_not_valid"
          showHelperText={notValidExtraData}
        />

      </View>

      <VFButton
        title='book_appointment_add_location_button_title'
        style={styles.buttonStyle}
        disabled={isButtonDisabled()}
        onPress={onButtonPress}
      />

    </QuickActionMenu>
  )
}
AddLocation.defaultProps = {
  isVisible: false,
  toggleModal: () => { },
  setSaveInfo: () => { }
}
AddLocation.propTypes = {
  isVisible: PropTypes.bool,
  toggleModal: PropTypes.func,
  citiesOptions: PropTypes.array,
  addressInfo: PropTypes.object,
  setAddressInfo: PropTypes.func,
  setSaveInfo: PropTypes.func,
  continueToNextStep: PropTypes.func
}

export default AddLocation
